import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  showModal: boolean;
  title: string;
  description: string;
  handleConfirm: () => void;
  handleCancel: () => void;
};

export default function ConfirmationModal({
  showModal,
  title,
  description,
  handleConfirm,
  handleCancel,
}: Props) {
  const { t } = useTranslation();
  return (
    <Dialog open={showModal} onOpenChange={(open) => !open && handleCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            {t('COMMON.CANCEL')}
          </Button>
          <Button onClick={handleConfirm}>{t('COMMON.CONFIRM')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
